// extracted by mini-css-extract-plugin
export default {"select__wrapper":"Select_select__wrapper__yZq9+","select__label":"Select_select__label__lF1nv","select__dropdown":"Select_select__dropdown__FEcPf"};